// extracted by mini-css-extract-plugin
export default {"coll-guide-modal":"index_coll-guide-modal__fzOHO"};